/* eslint-disable react-hooks/exhaustive-deps */

import { Accordion, AccordionDetails, AccordionSummary, useTheme, withStyles, withTheme } from '@material-ui/core';
import { Grid, Box, Select, MenuItem, ThemeProvider, Tooltip, Typography, TextField, InputLabel, FormControl, FormControlLabel, Checkbox, Dialog, DialogTitle, DialogActions, Button, Paper } from '@mui/material';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Equity from 'modules/authorizations/details/homesale/equity/equity.component';
import Spinner from 'modules/common/spinner.component';
import { showToast } from 'modules/layout/layout.actions';
import {
  GET_HOMESALE_INFO_FAILURE,
} from 'modules/authorizations/store/types/homesaleTypes';
import {
  GET_AUTH_SUMMARY_FAILURE
} from 'modules/authorizations/store/types/authorizationTypes';
import {
  getHomesaleInfo,
} from 'modules/authorizations/store/actions/homesale.actions';
import {
  getAuthorizationSummary,
  setAuthId
} from 'modules/authorizations/store/actions/authorizations.actions';
import { TOAST_MESSAGE_SEVERITY_ERROR, TOAST_MESSAGE_SEVERITY_SUCCESS } from 'modules/layout/types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MORREALE_EQUITY_IMPORT_FAILURE } from 'modules/authorizations/store/types/dataManagementTypes';
import { morrealeEquityImport } from 'modules/authorizations/store/actions/dataManagement.actions';
import MultiRowForm from 'modules/common/multiRowForm.component';

const styles = theme => {
  return {
    row: {
      backgroundColor: theme.palette.common.white
    },
    inputGroup: {
      display: 'inline-flex',
      justifyContent: 'space-between'
    },
    root: {
      maxWidth: 170,
      marginRight: 10
    },
    extRoot: {
      width: 115,
      marginRight: 10
    },
    primaryContactRow: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      width: '100%'
    },
    primaryText: {
      paddingTop: 12,
      paddingRight: 5
    },
    newRow: {
      display: 'flex',
      flexDirection: 'column',
      //maxWidth: 1050
    }
  };
};

const MorrealeEquityImport = props => {
  const theme = useTheme();
  const { authOptions, expenseCodes } = props;

    const [isOpen, setIsOpen] = useState(false);
    const [openModal, setOpenModal] = useState(false);

      const [isLoading, setIsLoading] = useState(false);
      const [authId, setAuthId] = useState(null);
      const [equityId, setEquityId] = useState(null);
      const [equityOptions, setEquityOptions] = useState([]);

      const [appraisalAmount, setAppraisalAmount] = useState(0);
      const [attorneyFeeAmount, setAttorneyFeeAmount] = useState(0);
      const [closingFeeAmount, setClosingFeeAmount] = useState(0);
      const [closingDate, setClosingDate] = useState(null);
      const [commissionAmount, setCommissionAmount] = useState(0);
      const [corpEquityAdvance, setCorpEquityAdvance] = useState(0);
      const [corpEquityExpCode, setCorpEquityExpCode] = useState('');
      const [docPreparationAmount, setDocPreparationAmount] = useState(0);
      const [docTaxAmount, setDocTaxAmount] = useState(0);
      const [equityComments, setEquityComments] = useState('');
      const [equityStatusId, setEquityStatusId] = useState('00000000-0000-0000-0000-000000000000');
      const [equityTypeId, setEquityTypeId] = useState('00000000-0000-0000-0000-000000000000');
      const [equityVersion, setEquityVersion] = useState(0);
      const [firstLender, setFirstLender] = useState('');
      const [firstMortgageBalance, setFirstMortgageBalance] = useState(0);
      const [firstMortgageEscrow, setFirstMortgageEscrow] = useState(0);
      const [firstMortgageEscrowBalance, setFirstMortgageEscrowBalance] = useState(0);
      const [firstMortgageExpCode, setFirstMortgageExpCode] = useState('');
      const [firstMortgageDueFrom, setFirstMortgageDueFrom] = useState(null);
      const [firstMortgageInterestRate, setFirstMortgageInterestRate] = useState(0);
      const [firstMortgageProrationAmount, setFirstMortgageProrationAmount] = useState(0);
      const [firstMortgageProrationDate, setFirstMortgageProrationDate] = useState(null);
      const [firstMortgageLastPayment, setFirstMortgageLastPayment] = useState(null);
      const [firstMortgagePAndI, setFirstMortgagePAndI] = useState(0);
      const [firstMortgagePayment, setFirstMortgagePayment] = useState(0);
      const [firstMortgagePrincipal, setFirstMortgagePrincipal] = useState(0);
      const [firstMortgageTypeId, setFirstMortgageTypeId] = useState('00000000-0000-0000-0000-000000000000');
      const [holdbackAmount, setHoldbackAmount] = useState(0);
      const [holdbackCode, setHoldbackCode] = useState('');
      const [holdbackDesc, setHoldbackDesc] = useState('');
      const [inspectionAmount, setInspectionAmount] = useState(0);
      const [prorationDaysTypeId, setProrationDaysTypeId] = useState('00000000-0000-0000-0000-000000000000');
      const [prorationDate, setProrationDate] = useState(null);
      const [purchaseSalePrice, setPurchaseSalePrice] = useState(0);
      const [recordFeeAmount, setRecordFeeAmount] = useState(0);
      const [saleTypeId, setSaleTypeId] = useState('00000000-0000-0000-0000-000000000000');
      const [secondInterestProrationAmount, setSecondInterestProrationAmount] = useState(0);
      const [secondLender, setSecondLender] = useState('');
      const [secondMortgageBalance, setSecondMortgageBalance] = useState(0);
      const [secondMortgageExpCode, setSecondMortgageExpCode] = useState('');
      const [secondMortgageIntlDueForm, setSecondMortgageIntlDueForm] = useState(null);
      const [secondMortgageNextPaymentAmount, setSecondMortgageNextPaymentAmount] = useState(0);
      const [secondMortgageTypeId, setSecondMortgageTypeId] = useState('00000000-0000-0000-0000-000000000000');
      const [thirdExpCode, setThirdExpCode] = useState('');
      const [thirdInterestAmount, setThirdInterestAmount] = useState(0);
      const [thirdLender, setThirdLender] = useState('');
      const [thirdMortgageBalance, setThirdMortgageBalance] = useState(0);
      const [thirdMortgageTypeId, setThirdMortgageTypeId] = useState('00000000-0000-0000-0000-000000000000');
      const [titleWorkAmount, setTitleWorkAmount] = useState(0);
      const [corpEquityAdvanceCode, setCorpEquityAdvanceCode] = useState('');
      const [unpaidHOADues, setUnpaidHOADues] = useState(0);
      const [unpaidTaxes, setUnpaidTaxes] = useState(0);
      const [creditsCharges, setCreditsCharges] = useState([]);

      const [firstMortgage, setFirstMortgage] = useState(false);
      const [secondMortgage, setSecondMortgage] = useState(false);
      const [thirdMortgage, setThirdMortgage] = useState(false);
      const [taxInfo, setTaxInfo] = useState(false);

      const creditChargeTypes = [
        { title: 'Credit', id: '936fc501-7a03-4c78-83d5-7ac32113d426' },
        { title: 'Charge', id: '0b3d5218-484a-49e3-9ea5-939f58c7a3f2' },
        { title: '', id: '00000000-0000-0000-0000-000000000000' }
      ];

      const prorationDaysTypes = 
        props.allEnums && props.allEnums.prorationDaysTypes && props.allEnums.prorationDaysTypes.length > 0
      ? props.allEnums.prorationDaysTypes.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];;;
      
      const saleTypes = 
        props.allEnums && props.allEnums.homesaleProgramTypes && props.allEnums.homesaleProgramTypes.length > 0
      ? props.allEnums.homesaleProgramTypes.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];;
      
      const equityTypes = 
        props.allEnums && props.allEnums.equityTypes && props.allEnums.equityTypes.length > 0
      ? props.allEnums.equityTypes.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];;;
  
  const equityStatusTypes =
    props.allEnums && props.allEnums.equityStatuses && props.allEnums.equityStatuses.length > 0
      ? props.allEnums.equityStatuses.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

    const expenseCodeSearchInfo = {
      searchingColumns: [
        { name: 'expenseCodeId', title: 'Id' },
        { name: 'expenseCodeCode', title: 'Expense Code' },
        { name: 'expenseCodeDescription', title: 'Description' },
        { name: 'classification', title: 'Classification' }
      ],
      searchingColumnExtensions: [
        { columnName: 'expenseCodeId', width: 150 },
        { columnName: 'expenseCodeCode', width: 175 },
        { name: 'expenseCodeDescription', width: 250 },
        { name: 'classification', width: 175 }
      ],
      // Not all expense codes have been extracted from the External Tables so use the first few for now
      searchingRows: expenseCodes ? expenseCodes.slice(0, 10) : null,
      idKey: 'expenseCodeId',
      nameKey: 'expenseCodeCode'
    };

      const formLabel = 'Credits/Charges';
      const creditChargesHeader = { title: 'Credits/Charges' };

      const creditChargesFormFields = [
        {
          name: 'amount',
          type: 'money',
          label: 'Amount',
        },
        {
          name: 'description',
          type: 'text',
          label: 'Description',
          },
        { name: 'creditChargeTypeId', type: 'dropdown-v2', options: creditChargeTypes, label: 'Credit Charge Type' },
        { name: 'expenseCodeId', type: 'advanced-search', searchInfo: expenseCodeSearchInfo, label: 'Expense Code', displayKey: 'expenseCodeCode' },
      ];

      const createNewCreditChargeRowFunc = () => {
        return {
          homeEquityCreditChargeId: 0,
          homesaleEquityId: 0,
          amount: 0,
          description: '',
          creditChargeTypeId: 0,
          expenseCodeId: 0,
          addedBy: 0,
          addedOn: new Date()
        };
      };

    const makeRequests = async newAuthId => {
        setIsLoading(true);
    
        await props.setAuthId(newAuthId);
    
        const [
          authSummaryResp,
          homeSaleInfoResp
        ] = await Promise.all([
          props.getAuthorizationSummary(newAuthId),
          props.getHomesaleInfo(newAuthId),
        ]);
    
        setIsLoading(false);
    
        if (authSummaryResp.type === GET_AUTH_SUMMARY_FAILURE) {
          props.showToast('Failed to retrieve authorization info, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
          return;
        }
    
        if (homeSaleInfoResp.type === GET_HOMESALE_INFO_FAILURE) {
          props.showToast('Failed to retrieve homesale info, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
          return;
        }
        else {
          setEquityOptions(homeSaleInfoResp.response.equities);
        }
    
      };
    
      useEffect(() => {
        if (authId) {
          makeRequests(authId);
        }
      }, [authId]);

  const importEquity = async () => {
    setIsLoading(true);

    let newValues = {
      homesaleEquity: {
        homesaleEquityId: 0,
        authorizationId: authOptions.find(a => a.fileId === authId).fileNumber,
        appraisalAmount: appraisalAmount,
        attorneyFeeAmount: attorneyFeeAmount,
        closingFeeAmount: closingFeeAmount,
        closingDate: closingDate,
        commissionAmount: commissionAmount,
        corpEquityAdvance: corpEquityAdvance,
        corpEquityExpCode: corpEquityExpCode,
        docPreparationAmount: docPreparationAmount,
        docTaxAmount: docTaxAmount,
        equityComments: equityComments,
        equityStatusId: equityStatusId,
        equityTypeId: equityTypeId,
        equityVersion: equityVersion,
        firstLender: firstLender,
        firstMortgageBalance: firstMortgageBalance,
        firstMortgageEscrow: firstMortgageEscrow,
        firstMortgageEscrowBalance: firstMortgageEscrowBalance,
        firstMortgageExpCode: firstMortgageExpCode,
        firstMortgageDueFrom: firstMortgageDueFrom,
        firstMortgageInterestRate: firstMortgageInterestRate,
        firstMortgageProrationAmount: firstMortgageProrationAmount,
        firstMortgageProrationDate: firstMortgageProrationDate,
        firstMortgageLastPayment: firstMortgageLastPayment,
        firstMortgagePAndI: firstMortgagePAndI,
        firstMortgagePayment: firstMortgagePayment,
        firstMortgagePrincipal: firstMortgagePrincipal,
        firstMortgageTypeId: firstMortgageTypeId,
        holdbackAmount: holdbackAmount,
        holdbackCode: holdbackCode,
        holdbackDesc: holdbackDesc,
        inspectionAmount: inspectionAmount,
        prorationDaysTypeId: prorationDaysTypeId && prorationDaysTypeId !== null ? prorationDaysTypeId : '00000000-0000-0000-0000-000000000000',
        prorationDate: prorationDate,
        purchaseSalePrice: purchaseSalePrice,
        recordFeeAmount: recordFeeAmount,
        saleTypeId: saleTypeId && saleTypeId !== null ? saleTypeId : '00000000-0000-0000-0000-000000000000',
        secondInterestProrationAmount: secondInterestProrationAmount,
        secondLender: secondLender,
        secondMortgageBalance: secondMortgageBalance,
        secondMortgageExpCode: secondMortgageExpCode,
        secondMortgageIntlDueForm: secondMortgageIntlDueForm,
        secondMortgageNextPaymentAmount: secondMortgageNextPaymentAmount,
        secondMortgageTypeId: secondMortgageTypeId,
        thirdExpCode: thirdExpCode,
        thirdInterestAmount: thirdInterestAmount,
        thirdLender: thirdLender,
        thirdMortgageBalance: thirdMortgageBalance,
        thirdMortgageTypeId: thirdMortgageTypeId,
        titleWorkAmount: titleWorkAmount,
        corpEquityAdvanceCode: corpEquityAdvanceCode,
        unpaidHOADues: unpaidHOADues,
        unpaidTaxes: unpaidTaxes,
        addedBy: 0,
        addedOn: new Date(),
        modifiedBy: 0,
        modifiedOn: new Date(), 
      },
      creditCharges: creditsCharges.map(c => ({
        homeEquityCreditChargeId: c.homeEquityCreditChargeId,
        amount: parseInt(c.amount),
        description: c.description,
        creditChargeTypeId: c.creditChargeTypeId,
        expenseCodeId: c.expenseCodeCode ? expenseCodes.find(e => e.expenseCodeCode === c.expenseCodeCode)?.expenseCodeId : 0,
        addedBy: c.addedBy,
        addedOn: c.addedOn
      }))
    }

    const resp = await props.morrealeEquityImport(newValues);
    if(resp.type === MORREALE_EQUITY_IMPORT_FAILURE) {
      props.showToast('Failed to import equity, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
    }
    else {
        const resp = await props.getHomesaleInfo(authId);
        if (resp.type === GET_HOMESALE_INFO_FAILURE) {
          props.showToast('Failed to retrieve homesale info, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        }
        else {
          setEquityOptions(resp.equities);
          if(equityOptions && equityOptions.length > 0) {
            setEquityId(equityOptions[0].equityInfo.homesaleEquityId);
          }
          props.showToast('Equity imported successfully', { severity: TOAST_MESSAGE_SEVERITY_SUCCESS });
        }
    }
    setOpenModal(false);
    setIsLoading(false);
  };

  return (
    <div>
    <Accordion
        expanded={isOpen}
        onChange={() => {
            setIsOpen(!isOpen);
        }}
        >
      <AccordionSummary
        expandIcon={
          <Box color={theme.palette.secondary.main}>
            <ExpandMoreIcon color="inherit" />
          </Box>
        }
      >
        <div className={props.classes.newRow}>
          <h2>Morreale Homesale Equity Import</h2>
        </div>
      </AccordionSummary>
      <AccordionDetails>
            <ThemeProvider theme={theme}>
                <Box>
                    <div className="row justify-space-between">
                        <Box sx={{ display: 'flex' }}>
                            <Tooltip title="Estimates" key="Estimates" placement="right">
                                <FontAwesomeIcon icon={['fas', 'file-contract']} size="2x" />
                            </Tooltip>
                            <Typography variant="h5" sx={{ paddingLeft: '20px', fontSize: '1.3125rem', fontWeight: 'bold' }}>
                                Homesale Equity Preview
                            </Typography>
                        </Box>
                        {authOptions && (
                            <Box sx={{ display: 'flex' }}>
                                <div className={props.classes.mb2}>
                                <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem', paddingTop: '16px' }}>
                                    Authorization
                                </Typography>
                                </div>
                                <Select
                                labelId={'authSelected'}
                                key={'authSelected'}
                                label={''}
                                name={'authSelected'}
                                value={authId}
                                sx={{ maxWidth: '360px', minWidth: '180px' }}
                                onChange={e => {
                                    setAuthId(e.target.value);
                                    makeRequests(e.target.value);
                                }}
                                >
                                {authOptions.map(opt => (
                                    <MenuItem key={opt.fileId} value={opt.fileId} sx={{ margin: 'dense' }}>
                                    {opt.eeFullName} - {opt.fileNumber}
                                    </MenuItem>
                                ))}
                                </Select>
                            </Box>
                            )}
                    </div>
                    <Paper
                    square
                    sx={{
                      position: 'relative',
                      width: '100%',
                      zIndex: 2,
                      marginTop: '10px',
                      marginBottom: '10px',
                      paddingBottom: '10px',
                      paddingTop: '5px'
                    }}
                    >
                    <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '10px' }}>
                        <Box sx={{ display: 'flex', flexDirection: 'row', paddingLeft: '20px' }}>
                        <Select
                            labelId={'equityId'}
                            key={'equityId'}
                            label={''}
                            name={'equityId'}
                            value={equityId}
                            sx={{ maxWidth: '360px', minWidth: '180px' }}
                            onChange={e => setEquityId(e.target.value)}
                        >
                            { equityOptions &&
                            equityOptions.map((opt, index) => (
                                <MenuItem key={opt.equityInfo.homesaleEquityId} value={opt.equityInfo.homesaleEquityId} sx={{ margin: 'dense' }}>
                                {`${
                                    equityStatusTypes.find(e => e.id === opt.equityInfo.equityStatusId) !== undefined
                                    ? equityStatusTypes.find(e => e.id === opt.equityInfo.equityStatusId).title
                                    : ''
                                } (V${index + 1})`}
                                </MenuItem>
                            ))}
                        </Select>
                        <Button
                          color="secondary"
                          type="submit"
                          variant="contained"
                          sx={{ maxHeight: '40px', marginLeft: '12px', marginTop: '8px' }}
                          onClick={() => setOpenModal(true)}
                        >
                          {' '}
                          Import Equity{' '}
                        </Button>
                        </Box>
                    </Box>
                    </Paper>
                            <Box>
                                <Equity equityOptions={equityOptions} id={authId} equityId={equityId} isReadOnly={true} enumerations={props.allEnums} />
                            </Box>
                </Box>
        </ThemeProvider>
      </AccordionDetails>
    </Accordion>
    <Dialog open={openModal} fullWidth={false} maxWidth={'lg'}>
            <DialogTitle>New Equity Record</DialogTitle>
            <Grid container spacing={{ xs: 1, md: 1 }} sx={{ padding: '30px', paddingTop: '0px' }}>
                {/* <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '20px' }}> */}
                  <Grid container item spacing={4} sx={{ margin: '20px' }}>
                    <Box sx={{ marginRight: '20px' }}>
                    <FormControl sx={{ marginTop: '6px' }}>
                        <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={'vendorTypeId'}>
                            Equity Status
                        </InputLabel>
                        <Select
                            labelId={'equityStatusId'}
                            key={'equityStatusId'}
                            label={'equityStatusId'}
                            name={'equityStatusId'}
                            required={true}
                            disabled={false}
                            value={equityStatusId}
                            variant="standard"
                            margin="dense"
                            sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                            onChange={e => setEquityStatusId(e.target.value)}
                        >
                            {equityStatusTypes.map(opt => (
                                <MenuItem key={opt.id} value={opt.id} sx={{ margin: 'dense' }} disabled={false}>
                                    {opt.title} 
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <Typography variant="caption" display="block" color="primary">
                        Required
                    </Typography>
                    </Box>
                    <Box>
                    <FormControl sx={{ marginTop: '6px' }}>
                        <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={'vendorTypeId'}>
                            Sale Type
                        </InputLabel>
                        <Select
                            labelId={'saleTypeId'}
                            key={'saleTypeId'}
                            label={'saleTypeId'}
                            name={'saleTypeId'}
                            required={false}
                            disabled={false}
                            value={saleTypeId}
                            margin="dense"
                            variant="standard"
                            sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                            onChange={e => setSaleTypeId(e.target.value)}
                        >
                            {saleTypes.map(opt => (
                                <MenuItem key={opt.id} value={opt.id} sx={{ margin: 'dense' }} disabled={false}>
                                    {opt.title} 
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <Typography variant="caption" display="block" color="primary">
                        Required
                    </Typography>
                    </Box>
                </Grid>
                <Grid container item spacing={12} sx={{ marginLeft: '20px', marginTop: '10px', marginBottom: '10px' }}>
                    <Typography variant="caption" display="block" color="primary" sx={{ fontSize: '1.125rem', fontWeight: 'bold' }}>
                        Equity Details
                    </Typography>
                </Grid>
                <Grid container item spacing={12} sx={{ margin: '20px' }}>
                {/* </Box> */}
                {/* <Box sx={{ display: 'flex', flexDirection: 'row' }}> */}
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <FormControl sx={{ marginTop: '6px' }}>
                        <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={'vendorTypeId'}>
                            Equity Type
                        </InputLabel>
                        <Select
                            labelId={'equityTypeId'}
                            key={'equityTypeId'}
                            label={'equityTypeId'}
                            name={'equityTypeId'}
                            required={true}
                            disabled={false}
                            value={equityTypeId}
                            margin="dense"
                            variant="standard"
                            sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                            onChange={e => setEquityTypeId(e.target.value)}
                        >
                            {equityTypes.map(opt => (
                                <MenuItem key={opt.id} value={opt.id} sx={{ margin: 'dense' }} disabled={false}>
                                    {opt.title} 
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <TextField
                      key={'appraisalAmount'}
                      label={'Appraisal Amount'}
                      name={'appraisalAmount'}
                      required={false}
                      variant="outlined"
                      sx={{ maxWidth: '360px' }}
                      value={appraisalAmount}
                      onChange={(e) => setAppraisalAmount(e.target.value)}
                      type="money"
                      InputLabelProps={{ shrink: true }}
                    />
                </Box>
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <TextField
                      key={'attorneyFeeAmount'}
                      label={'Attorney Fee Amount'}
                      name={'attorneyFeeAmount'}
                      required={false}
                      variant="outlined"
                      sx={{ maxWidth: '360px' }}
                      value={attorneyFeeAmount}
                      onChange={(e) => setAttorneyFeeAmount(e.target.value)}
                      type="money"
                      InputLabelProps={{ shrink: true }}
                    />
                </Box>
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <TextField
                      key={'closingFeeAmount'}
                      label={'Closing Fee Amount'}
                      name={'closingFeeAmount'}
                      required={false}
                      variant="outlined"
                      sx={{ maxWidth: '360px' }}
                      value={closingFeeAmount}
                      onChange={(e) => setClosingFeeAmount(e.target.value)}
                      type="money"
                      InputLabelProps={{ shrink: true }}
                    />
                </Box>
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <TextField
                        key={'closingDate'}
                        label={'Closing Date'}
                        name={'closingDate'}
                        value={closingDate}
                        variant="outlined"
                        required={false}
                        sx={{ maxWidth: '360px' }}
                        type="date"
                        onChange={(e) => setClosingDate(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                    />
                </Box>
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <TextField
                      key={'commissionAmount'}
                      label={'Commission Amount'}
                      name={'commissionAmount'}
                      required={false}
                      variant="outlined"
                      sx={{ maxWidth: '360px' }}
                      value={commissionAmount}
                      onChange={(e) => setCommissionAmount(e.target.value)}
                      type="money"
                      InputLabelProps={{ shrink: true }}
                    />
                </Box>
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <TextField
                      key={'corpEquityAdvance'}
                      label={'Corp Equity Advance'}
                      name={'corpEquityAdvance'}
                      required={false}
                      variant="outlined"
                      sx={{ maxWidth: '360px' }}
                      value={corpEquityAdvance}
                      onChange={(e) => setCorpEquityAdvance(e.target.value)}
                      type="money"
                      InputLabelProps={{ shrink: true }}
                    />
                </Box>
                <Box sx={{ marginRight: '20px', marginBottom: '20px'   }}>
                    <TextField
                      key={'corpEquityExpCode'}
                      label={'Corp Equity Expense Code'}
                      name={'corpEquityExpCode'}
                      required={false}
                      variant="outlined"
                      sx={{ maxWidth: '360px' }}
                      value={corpEquityExpCode}
                      onChange={(e) => setCorpEquityExpCode(e.target.value)}
                      type="text"
                      InputLabelProps={{ shrink: true }}
                    />
                </Box>
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <TextField
                      key={'docPreparationAmount'}
                      label={'Document Preparation Amount'}
                      name={'docPreparationAmount'}
                      required={false}
                      variant="outlined"
                      sx={{ maxWidth: '360px' }}
                      value={docPreparationAmount}
                      onChange={(e) => setDocPreparationAmount(e.target.value)}
                      type="money"
                      InputLabelProps={{ shrink: true }}
                    />
                </Box>
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <TextField
                      key={'docTaxAmount'}
                      label={'Document Tax Amount'}
                      name={'docTaxAmount'}
                      required={false}
                      variant="outlined"
                      sx={{ maxWidth: '360px' }}
                      value={docTaxAmount}
                      onChange={(e) => setDocTaxAmount(e.target.value)}
                      type="money"
                      InputLabelProps={{ shrink: true }}
                    />
                </Box>
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <TextField
                      key={'equityComments'}
                      label={'Equity Comments'}
                      name={'equityComments'}
                      required={false}
                      variant="outlined"
                      sx={{ maxWidth: '360px' }}
                      value={equityComments}
                      onChange={(e) => setEquityComments(e.target.value)}
                      type="text"
                      InputLabelProps={{ shrink: true }}
                    />
                </Box>
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <TextField
                      key={'equityVersion'}
                      label={'Equity Version'}
                      name={'equityVersion'}
                      required={false}
                      variant="outlined"
                      sx={{ maxWidth: '360px' }}
                      value={equityVersion}
                      onChange={(e) => setEquityVersion(e.target.value)}
                      type="number"
                      InputLabelProps={{ shrink: true }}
                    />
                </Box>
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <FormControlLabel
                        control={
                          <Checkbox
                            key={'firstMortgage'}
                            name={'firstMortgage'}
                            checked={firstMortgage || false}
                            onChange={(e) => setFirstMortgage(e.target.checked )}
                          />
                        }
                        label={'First Mortgage'}
                      />
                </Box>
                { firstMortgage && 
                <>
                   <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <TextField
                      key={'firstLender'}
                      label={'First Lender'}
                      name={'firstLender'}
                      required={false}
                      variant="outlined"
                      sx={{ maxWidth: '360px' }}
                      value={firstLender}
                      onChange={(e) => setFirstLender(e.target.value)}
                      type="text"
                      InputLabelProps={{ shrink: true }}
                    />
                </Box>
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <TextField
                      key={'firstMortgageBalance'}
                      label={'First Mortgage Balance'}
                      name={'firstMortgageBalance'}
                      required={false}
                      variant="outlined"
                      sx={{ maxWidth: '360px' }}
                      value={firstMortgageBalance}
                      onChange={(e) => setFirstMortgageBalance(e.target.value)}
                      type="money"
                      InputLabelProps={{ shrink: true }}
                    />
                </Box>
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <TextField
                      key={'firstMortgageEscrow'}
                      label={'First Mortgage Escrow'}
                      name={'firstMortgageEscrow'}
                      required={false}
                      variant="outlined"
                      sx={{ maxWidth: '360px' }}
                      value={firstMortgageEscrow}
                      onChange={(e) => setFirstMortgageEscrow(e.target.value)}
                      type="money"
                      InputLabelProps={{ shrink: true }}
                    />
                </Box>
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <TextField
                      key={'firstMortgageEscrowBalance'}
                      label={'First Mortgage Escrow Balance'}
                      name={'firstMortgageEscrowBalance'}
                      required={false}
                      variant="outlined"
                      sx={{ maxWidth: '360px' }}
                      value={firstMortgageEscrowBalance}
                      onChange={(e) => setFirstMortgageEscrowBalance(e.target.value)}
                      type="money"
                      InputLabelProps={{ shrink: true }}
                    />
                </Box>
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <TextField
                      key={'firstMortgageExpCode'}
                      label={'First Mortgage Expense Code'}
                      name={'firstMortgageExpCode'}
                      required={false}
                      variant="outlined"
                      sx={{ maxWidth: '360px' }}
                      value={firstMortgageExpCode}
                      onChange={(e) => setFirstMortgageExpCode(e.target.value)}
                      type="text"
                      InputLabelProps={{ shrink: true }}
                    />
                </Box>
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <TextField
                      key={'firstMortgageDueFrom'}
                      label={'First Mortgage Due From'}
                      name={'firstMortgageDueFrom'}
                      required={false}
                      variant="outlined"
                      sx={{ maxWidth: '360px' }}
                      value={firstMortgageDueFrom}
                      onChange={(e) => setFirstMortgageDueFrom(e.target.value)}
                      type="date"
                      InputLabelProps={{ shrink: true }}
                    />
                </Box>
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <TextField
                      key={'firstMortgageInterestRate'}
                      label={'First Mortgage Interest Rate'}
                      name={'firstMortgageInterestRate'}
                      required={false}
                      variant="outlined"
                      sx={{ maxWidth: '360px' }}
                      value={firstMortgageInterestRate}
                      onChange={(e) => setFirstMortgageInterestRate(e.target.value)}
                      type="number"
                      InputLabelProps={{ shrink: true }}
                    />
                </Box>
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <TextField
                      key={'firstMortgageProrationAmount'}
                      label={'First Mortgage Proration Amount'}
                      name={'firstMortgageProrationAmount'}
                      required={false}
                      variant="outlined"
                      sx={{ maxWidth: '360px' }}
                      value={firstMortgageProrationAmount}
                      onChange={(e) => setFirstMortgageProrationAmount(e.target.value)}
                      type="money"
                      InputLabelProps={{ shrink: true }}
                    />
                </Box>
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <TextField
                      key={'firstMortgageProrationDate'}
                      label={'First Mortgage Proration Date'}
                      name={'firstMortgageProrationDate'}
                      required={false}
                      variant="outlined"
                      sx={{ maxWidth: '360px' }}
                      value={firstMortgageProrationDate}
                      onChange={(e) => setFirstMortgageProrationDate(e.target.value)}
                      type="date"
                      InputLabelProps={{ shrink: true }}
                    />
                </Box>
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <TextField
                      key={'firstMortgageLastPayment'}
                      label={'First Mortgage Last Payment'}
                      name={'firstMortgageLastPayment'}
                      required={false}
                      variant="outlined"
                      sx={{ maxWidth: '360px' }}
                      value={firstMortgageLastPayment}
                      onChange={(e) => setFirstMortgageLastPayment(e.target.value)}
                      type="money"
                      InputLabelProps={{ shrink: true }}
                    />
                </Box>
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <TextField
                      key={'firstMortgagePAndI'}
                      label={'First Mortgage P & I'}
                      name={'firstMortgagePAndI'}
                      required={false}
                      variant="outlined"
                      sx={{ maxWidth: '360px' }}
                      value={firstMortgagePAndI}
                      onChange={(e) => setFirstMortgagePAndI(e.target.value)}
                      type="money"
                      InputLabelProps={{ shrink: true }}
                    />
                </Box>
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <TextField
                      key={'firstMortgagePayment'}
                      label={'First Mortgage Payment'}
                      name={'firstMortgagePayment'}
                      required={false}
                      variant="outlined"
                      sx={{ maxWidth: '360px' }}
                      value={firstMortgagePayment}
                      onChange={(e) => setFirstMortgagePayment(e.target.value)}
                      type="money"
                      InputLabelProps={{ shrink: true }}
                    />
                </Box>
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }} >
                    <TextField
                      key={'firstMortgagePrincipal'}
                      label={'First Mortgage Principal'}
                      name={'firstMortgagePrincipal'}
                      required={false}
                      variant="outlined"
                      sx={{ maxWidth: '360px' }}
                      value={firstMortgagePrincipal}
                      onChange={(e) => setFirstMortgagePrincipal(e.target.value)}
                      type="money"
                      InputLabelProps={{ shrink: true }}
                    />
                </Box>
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <FormControl sx={{ marginTop: '6px' }}>
                        <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={'vendorTypeId'}>
                            First Mortgage Type
                        </InputLabel>
                        <Select
                            labelId={'firstMortgageTypeId'}
                            key={'firstMortgageTypeId'}
                            label={'firstMortgageTypeId'}
                            name={'firstMortgageTypeId'}
                            required={false}
                            disabled={false}
                            value={firstMortgageTypeId}
                            margin="dense"
                            variant="standard"
                            sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                            onChange={e => setFirstMortgageTypeId(e.target.value)}
                        >
                            {equityTypes.map(opt => (
                                <MenuItem key={opt.id} value={opt.id} sx={{ margin: 'dense' }} disabled={false}>
                                    {opt.title} 
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
                </>}
               <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <FormControlLabel
                        control={
                          <Checkbox
                            key={'secondMortgage'}
                            name={'secondMortgage'}
                            checked={secondMortgage || false}
                            onChange={(e) => setSecondMortgage(e.target.checked )}
                          />
                        }
                        label={'Second Mortgage'}
                      />
                </Box>
                { secondMortgage &&
                <>
                  <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <TextField
                      key={'secondLender'}
                      label={'Second Lender'}
                      name={'secondLender'}
                      required={false}
                      variant="outlined"
                      sx={{ maxWidth: '360px' }}
                      value={secondLender}
                      onChange={(e) => setSecondLender(e.target.value)}
                      type="text"
                      InputLabelProps={{ shrink: true }}
                    />
                </Box>
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <TextField
                      key={'secondMortgageBalance'}
                      label={'Second Mortgage Balance'}
                      name={'secondMortgageBalance'}
                      required={false}
                      variant="outlined"
                      sx={{ maxWidth: '360px' }}
                      value={secondMortgageBalance}
                      onChange={(e) => setSecondMortgageBalance(e.target.value)}
                      type="money"
                      InputLabelProps={{ shrink: true }}
                    />
                </Box>
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <TextField
                      key={'secondMortgageExpCode'}
                      label={'Second Mortgage Expense Code'}
                      name={'secondMortgageExpCode'}
                      required={false}
                      variant="outlined"
                      sx={{ maxWidth: '360px' }}
                      value={secondMortgageExpCode}
                      onChange={(e) => setSecondMortgageExpCode(e.target.value)}
                      type="text"
                      InputLabelProps={{ shrink: true }}
                    />
                </Box>
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <TextField
                      key={'secondMortgageIntlDueForm'}
                      label={'Second Mortgage International Due From'}
                      name={'secondMortgageIntlDueForm'}
                      required={false}
                      variant="outlined"
                      sx={{ maxWidth: '360px' }}
                      value={secondMortgageIntlDueForm}
                      onChange={(e) => setSecondMortgageIntlDueForm(e.target.value)}
                      type="money"
                      InputLabelProps={{ shrink: true }}
                    />
                </Box>
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <FormControl sx={{ marginTop: '6px' }}>
                        <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={'vendorTypeId'}>
                            Second Mortgage Type
                        </InputLabel>
                        <Select
                            labelId={'secondMortgageTypeId'}
                            key={'secondMortgageTypeId'}
                            label={'secondMortgageTypeId'}
                            name={'secondMortgageTypeId'}
                            required={false}
                            disabled={false}
                            value={secondMortgageTypeId}
                            margin="dense"
                            variant="standard"
                            sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                            onChange={e => setSecondMortgageTypeId(e.target.value)}
                        >
                            {equityTypes.map(opt => (
                                <MenuItem key={opt.id} value={opt.id} sx={{ margin: 'dense' }} disabled={false}>
                                    {opt.title} 
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <TextField
                      key={'secondMortgageNextPaymentAmount'}
                      label={'Second Mortgage Next Payment Amount'}
                      name={'secondMortgageNextPaymentAmount'}
                      required={false}
                      variant="outlined"
                      sx={{ maxWidth: '360px' }}
                      value={secondMortgageNextPaymentAmount}
                      onChange={(e) => setSecondMortgageNextPaymentAmount(e.target.value)}
                      type="money"
                      InputLabelProps={{ shrink: true }}
                    />
                </Box>
                </>}
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <FormControlLabel
                        control={
                          <Checkbox
                            key={'thirdMortgage'}
                            name={'thirdMortgage'}
                            checked={thirdMortgage || false}
                            onChange={(e) => setThirdMortgage(e.target.checked )}
                          />
                        }
                        label={'Third Mortgage'}
                      />
                </Box>
                { thirdMortgage &&
                <>
                  <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <TextField
                      key={'thirdLender'}
                      label={'Third Lender'}
                      name={'thirdLender'}
                      required={false}
                      variant="outlined"
                      sx={{ maxWidth: '360px' }}
                      value={thirdLender}
                      onChange={(e) => setThirdLender(e.target.value)}
                      type="text"
                      InputLabelProps={{ shrink: true }}
                    />
                </Box>
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <TextField
                      key={'thirdExpCode'}
                      label={'Third Expense Code'}
                      name={'thirdExpCode'}
                      required={false}
                      variant="outlined"
                      sx={{ maxWidth: '360px' }}
                      value={thirdExpCode}
                      onChange={(e) => setThirdExpCode(e.target.value)}
                      type="text"
                      InputLabelProps={{ shrink: true }}
                    />
                </Box>
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <TextField
                      key={'thirdInterestAmount'}
                      label={'Third Interest Amount'}
                      name={'thirdInterestAmount'}
                      required={false}
                      variant="outlined"
                      sx={{ maxWidth: '360px' }}
                      value={thirdInterestAmount}
                      onChange={(e) => setThirdInterestAmount(e.target.value)}
                      type="money"
                      InputLabelProps={{ shrink: true }}
                    />
                </Box>
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }} >
                    <FormControl sx={{ marginTop: '6px' }}>
                        <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={'vendorTypeId'}>
                            Third Mortgage Type
                        </InputLabel>
                        <Select
                            labelId={'thirdMortgageTypeId'}
                            key={'thirdMortgageTypeId'}
                            label={'thirdMortgageTypeId'}
                            name={'thirdMortgageTypeId'}
                            required={false}
                            disabled={false}
                            value={thirdMortgageTypeId}
                            margin="dense"
                            variant="standard"
                            sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                            onChange={e => setThirdMortgageTypeId(e.target.value)}
                        >
                            {equityTypes.map(opt => (
                                <MenuItem key={opt.id} value={opt.id} sx={{ margin: 'dense' }} disabled={false}>
                                    {opt.title} 
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <TextField
                      key={'thirdMortgageBalance'}
                      label={'Third Mortgage Balance'}
                      name={'thirdMortgageBalance'}
                      required={false}
                      variant="outlined"
                      sx={{ maxWidth: '360px' }}
                      value={thirdMortgageBalance}
                      onChange={(e) => setThirdMortgageBalance(e.target.value)}
                      type="money"
                      InputLabelProps={{ shrink: true }}
                    />
                </Box>
                </>
                }
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <FormControlLabel
                        control={
                          <Checkbox
                            key={'taxInfo'}
                            name={'taxInfo'}
                            checked={taxInfo || false}
                            onChange={(e) => setTaxInfo(e.target.checked )}
                          />
                        }
                        label={'Tax Info'}
                      />
                </Box>
                { taxInfo &&
                <>
                  <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <TextField
                      key={'holdbackAmount'}
                      label={'Holdback Amount'}
                      name={'holdbackAmount'}
                      required={false}
                      variant="outlined"
                      sx={{ maxWidth: '360px' }}
                      value={holdbackAmount}
                      onChange={(e) => setHoldbackAmount(e.target.value)}
                      type="money"
                      InputLabelProps={{ shrink: true }}
                    />
                </Box>
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <TextField
                      key={'holdbackCode'}
                      label={'Holdback Code'}
                      name={'holdbackCode'}
                      required={false}
                      variant="outlined"
                      sx={{ maxWidth: '360px' }}
                      value={holdbackCode}
                      onChange={(e) => setHoldbackCode(e.target.value)}
                      type="text"
                      InputLabelProps={{ shrink: true }}
                    />
                </Box>
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <TextField
                      key={'holdbackDesc'}
                      label={'Holdback Description'}
                      name={'holdbackDesc'}
                      required={false}
                      variant="outlined"
                      sx={{ maxWidth: '360px' }}
                      value={holdbackDesc}
                      onChange={(e) => setHoldbackDesc(e.target.value)}
                      type="text"
                      InputLabelProps={{ shrink: true }}
                    />
                </Box>
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <TextField
                      key={'inspectionAmount'}
                      label={'Inspection Amount'}
                      name={'inspectionAmount'}
                      required={false}
                      variant="outlined"
                      sx={{ maxWidth: '360px' }}
                      value={inspectionAmount}
                      onChange={(e) => setInspectionAmount(e.target.value)}
                      type="money"
                      InputLabelProps={{ shrink: true }}
                    />
                </Box>
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <FormControl sx={{ marginTop: '6px' }}>
                        <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={'vendorTypeId'}>
                            Proration Days Type
                        </InputLabel>
                        <Select
                            labelId={'prorationDaysTypeId'}
                            key={'prorationDaysTypeId'}
                            label={'prorationDaysTypeId'}
                            name={'prorationDaysTypeId'}
                            required={false}
                            disabled={false}
                            value={prorationDaysTypeId}
                            margin="dense"
                            variant="standard"
                            sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                            onChange={e => setProrationDaysTypeId(e.target.value)}
                        >
                            {prorationDaysTypes.map(opt => (
                                <MenuItem key={opt.id} value={opt.id} sx={{ margin: 'dense' }} disabled={false}>
                                    {opt.title} 
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <TextField
                      key={'prorationDate'}
                      label={'Proration Date'}
                      name={'prorationDate'}
                      required={false}
                      variant="outlined"
                      sx={{ maxWidth: '360px' }}
                      value={prorationDate}
                      onChange={(e) => setProrationDate(e.target.value)}
                      type="date"
                      InputLabelProps={{ shrink: true }}
                    />
                </Box>
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <TextField
                      key={'purchaseSalePrice'}
                      label={'Purchase/Sale Price'}
                      name={'purchaseSalePrice'}
                      required={false}
                      variant="outlined"
                      sx={{ maxWidth: '360px' }}
                      value={purchaseSalePrice}
                      onChange={(e) => setPurchaseSalePrice(e.target.value)}
                      type="money"
                      InputLabelProps={{ shrink: true }}
                    />
                </Box>
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <TextField
                      key={'recordFeeAmount'}
                      label={'Record Fee Amount'}
                      name={'recordFeeAmount'}
                      required={false}
                      variant="outlined"
                      sx={{ maxWidth: '360px' }}
                      value={recordFeeAmount}
                      onChange={(e) => setRecordFeeAmount(e.target.value)}
                      type="money"
                      InputLabelProps={{ shrink: true }}
                    />
                </Box>
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <TextField
                      key={'secondInterestProrationAmount'}
                      label={'Second Interest Proration Amount'}
                      name={'secondInterestProrationAmount'}
                      required={false}
                      variant="outlined"
                      sx={{ maxWidth: '360px' }}
                      value={secondInterestProrationAmount}
                      onChange={(e) => setSecondInterestProrationAmount(e.target.value)}
                      type="money"
                      InputLabelProps={{ shrink: true }}
                    />
                </Box>
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <TextField
                      key={'titleWorkAmount'}
                      label={'Title Work Amount'}
                      name={'titleWorkAmount'}
                      required={false}
                      variant="outlined"
                      sx={{ maxWidth: '360px' }}
                      value={titleWorkAmount}
                      onChange={(e) => setTitleWorkAmount(e.target.value)}
                      type="money"
                      InputLabelProps={{ shrink: true }}
                    />
                </Box>
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <TextField
                      key={'corpEquityAdvanceCode'}
                      label={'Corp Equity Advance Code'}
                      name={'corpEquityAdvanceCode'}
                      required={false}
                      variant="outlined"
                      sx={{ maxWidth: '360px' }}
                      value={corpEquityAdvanceCode}
                      onChange={(e) => setCorpEquityAdvanceCode(e.target.value)}
                      type="text"
                      InputLabelProps={{ shrink: true }}
                    />
                </Box>
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <TextField
                      key={'unpaidHOADues'}
                      label={'Unpaid HOA Dues Amount'}
                      name={'unpaidHOADues'}
                      required={false}
                      variant="outlined"
                      sx={{ maxWidth: '360px' }}
                      value={unpaidHOADues}
                      onChange={(e) => setUnpaidHOADues(e.target.value)}
                      type="money"
                      InputLabelProps={{ shrink: true }}
                    />
                </Box>
                <Box sx={{ marginRight: '20px', marginBottom: '20px' }}>
                    <TextField
                      key={'unpaidTaxes'}
                      label={'Unpaid Taxes Amount'}
                      name={'unpaidTaxes'}
                      required={false}
                      variant="outlined"
                      sx={{ maxWidth: '360px' }}
                      value={unpaidTaxes}
                      onChange={(e) => setUnpaidTaxes(e.target.value)}
                      type="money"
                      InputLabelProps={{ shrink: true }}
                    />
                </Box>
                </>
                }
                </Grid>
                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <MultiRowForm
                      formValues={ creditsCharges && creditsCharges.length > 0 ? creditsCharges.map(item => ({ ...item })) : []}
                      saveFunction={(newValues) => setCreditsCharges(newValues)}
                      formFields={creditChargesFormFields}
                      createNewRowFunc={createNewCreditChargeRowFunc}
                      formLabel={formLabel}
                      addRowLabel={'Add Credit/Charge'}
                      header={creditChargesHeader}
                    />
                </Grid>
            </Grid>

            <DialogActions sx={{ p: '1.25rem' }}>
                {isLoading && <Spinner />}
                {!isLoading && (
                    <>
                        <Button onClick={() => setOpenModal(false)}>Cancel</Button>
                        <Button
                            onClick={importEquity}
                            color="primary"
                            type="submit"
                            variant="contained"
                            
                        >
                            Import Equity
                        </Button>
                    </>
                )}
            </DialogActions>
        </Dialog>
    </div>
  );
}; 

MorrealeEquityImport.propTypes = {
  //clientRecordId: PropTypes.number,
  internalUsers: PropTypes.array,
  allEnums: PropTypes.object,
  //clientCustomFields: PropTypes.array,
};

const mapStateToProps = (state) => {
  const { allEnums } = state.enumerations;
  return {
    allEnums
  };
};
  
export default compose(
  withStyles(styles),
  withTheme,
  connect(mapStateToProps, {
    getAuthorizationSummary,
    setAuthId,
    getHomesaleInfo,
    morrealeEquityImport,
    showToast
  }),
)(MorrealeEquityImport);